import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {UntypedFormBuilder} from "@angular/forms";
import {MAT_DATE_RANGE_SELECTION_STRATEGY} from "@angular/material/datepicker";
import {HunaDateStrategyService} from "../../providers/service/huna-date-strategy.service";
import {MAT_DATE_FORMATS} from "@angular/material/core";
import {Subscription} from "rxjs";
import {rangeDate} from "../../providers/service/all-devices.service";
import {OpenDialogService, TypeSelectChipsDialog} from "../../providers/service/open-dialog.service";
import {isNotNullOrUndefined} from "../../providers/service/global-variables.service";

export const MY_FORMATS = {
    parse: {dateInput: {month: 'short', year: 'numeric', day: 'numeric'}},
    display: {
        dateInput: {month: 'short', year: 'numeric',},
        monthYearLabel: {year: 'numeric'}
    }
};
export const OptionDateStrategy = {
    provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
    useClass: HunaDateStrategyService
}

@Component({
    selector: 'app-next-after-data',
    templateUrl: './next-after-data.component.html',
    styleUrls: ['./next-after-data.component.scss'],
    providers: [
        // OptionDateStrategy,
        {
            provide: MAT_DATE_FORMATS,
            useValue: MY_FORMATS
        }
    ],
    standalone: false
})
export class NextAfterDataComponent implements OnInit, OnDestroy, OnChanges {

    @Output() dateChange = new EventEmitter<rangeDate>();

    // @Input()
    // currentDate: { fromDate: Date, toDate: Date } = {
    //     fromDate: new Date(), toDate: new Date()
    // };
    @Input() diabledButtonWeek = false;
    @Input() deltaDate: number | undefined | null = undefined;
    @Input() deltaMonth: number | undefined = undefined;
    @Input() deltaYear: number | undefined = undefined;
    @Input() rangeData = true;

    @Input() public disabled = false;

    @Input() changeCurrentDate: rangeDate | undefined | null;


    public today = new Date(Date.now());

    private subscriptions: Subscription[] = [];

    public rangeForm = this.fb.group(
        {
            start: Date.now(),
            end: Date.now()
        }
    );


    constructor(
        private fb: UntypedFormBuilder,
        private hunaDateService: HunaDateStrategyService,
        private openDialogService: OpenDialogService
    ) {

        const subscriptionWeek = this.rangeForm.get('end')?.valueChanges.subscribe((date) => {
            const fromDate = (this.rangeData) ? this.rangeForm.get('start')?.value : undefined;
            const toDate = this.rangeForm.get('end')?.value;
            if (toDate != null && fromDate != null) {
            }
            if (fromDate instanceof Date) {
                fromDate.setHours(0, 0, 0, 0)
            }
            if (toDate instanceof Date) {
                toDate.setHours(0, 0, 0, 0)
            }
            this.dateChange.emit({fromDate: fromDate, toDate: toDate})
        });
        if (subscriptionWeek != null) {
            this.subscriptions.push(subscriptionWeek!);
        }
    }

    ngOnInit(): void {
        if (!this.rangeData) {
            this.currentDate = {fromDate: this.currentDate.fromDate, toDate: new Date()};
        }
        if (this.deltaDate != null) {
            // const date = this.hunaDateService.getDateFromTo(Date.now(), +this.deltaDate);
            if (this.rangeData) {
                const toDate = new Date();
                toDate.setHours(0, 0, 0, 0)
                const fromDate = new Date(toDate);
                fromDate.setDate(fromDate.getDate() - this.deltaDate)
                this.currentDate = {fromDate, toDate};
            } else {
                this.currentDate = {fromDate: this.currentDate.fromDate, toDate: new Date()};
            }
        } else if (this.deltaMonth != null) {
            const date = this.hunaDateService.getDeltaMonth(new Date(), this.deltaMonth)
            this.currentDate = date;
        } else if (this.deltaYear != null) {
            const date = this.hunaDateService.getDeltaYear(new Date(), this.deltaYear)
            this.currentDate = date;
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (isNotNullOrUndefined(changes.changeCurrentDate) && changes.changeCurrentDate.currentValue) {
            if (changes.changeCurrentDate.currentValue.toDate && changes.changeCurrentDate.currentValue.fromDate) {
                setTimeout(() => {
                    if (this.rangeData) {
                        const date = changes.changeCurrentDate.currentValue;
                        this.currentDate = date;
                    } else {
                        const date = changes.changeCurrentDate.currentValue;
                        this.rangeForm.get('end')?.setValue(date.toDate, {emitEvent: true, onlySelf: true});
                    }
                }, 100)
            }
        }

    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }


    set currentDate(date) {
        this.rangeForm.get('end')?.setValue(date.toDate, {emitEvent: false, onlySelf: true});
        this.rangeForm.get('start')?.setValue(date.fromDate, {emitEvent: false, onlySelf: true});
    }

    get typeDate(): 'deltaYear' | 'deltaMonth' | 'deltaDate' {
        if (this.deltaYear != null) {
            return 'deltaYear'
        } else if (this.deltaMonth != null) {
            return 'deltaMonth'
        } else {
            return 'deltaDate'

        }
    }

    get currentDate(): rangeDate {
        if (this.rangeForm != null) {
            return {
                fromDate: this.rangeForm.get('start')!.value,
                toDate: this.rangeForm.get('end')!.value
            }
        } else {
            return {
                fromDate: new Date(),
                toDate: new Date()
            }
        }

    }


    beforeClick() {
        let date;
        if (this.deltaDate != undefined) {
            if (this.rangeData) {
                let start: Date;
                let end: Date;
                if (this.deltaDate == 0) {
                    start = new Date(this.currentDate.fromDate);
                    start.setHours(0, 0, 0, 0)
                    end = new Date(start);
                    end.setDate(end.getDate() - 1);
                    end.setHours(23, 59, 59, 0);
                    start.setDate(end.getDate());
                } else {
                    const deltaDate = this.deltaDate ? this.deltaDate : 7;
                    start = new Date(this.currentDate.fromDate);
                    start.setHours(0, 0, 0, 0)
                    end = new Date(start);
                    end.setHours(0, 0, 0, 0)
                    start.setDate(end.getDate() - deltaDate);
                }

                this.currentDate = {fromDate: start, toDate: end}


                // date = date = this.hunaDateService.getDateFromTo(this.currentDate.fromDate.getTime(), -this.deltaDate as number);
                // this.currentDate = date;
            } else {
                date = {fromDate: new Date(), toDate: new Date(this.currentDate.toDate.getTime())}
                date.toDate.setDate(date.toDate.getDate() - this.deltaDate as number);
                this.rangeForm.get('end')?.setValue(date.toDate, {emitEvent: true, onlySelf: true});
            }
        } else if (this.deltaMonth != undefined) {
            date = this.hunaDateService.getDeltaMonth(this.currentDate.fromDate, -this.deltaMonth as number);
            this.currentDate = date;
        } else if (this.deltaYear != undefined) {
            date = this.hunaDateService.getDeltaYear(this.currentDate.fromDate, -this.deltaYear as number);
            this.currentDate = date;
        }
    }

    nextClick() {
        let date;
        if (this.deltaDate != null) {
            if (this.rangeData) {
                let start: Date;
                let end: Date;
                if (this.deltaDate == 0) {
                    start = new Date(this.currentDate.fromDate);
                    start.setHours(0, 0, 0, 0)
                    end = new Date(start);
                    end.setDate(end.getDate() + 1);
                    end.setHours(23, 59, 59, 0);
                    start.setDate(end.getDate());
                } else {
                    const deltaDate = this.deltaDate ? this.deltaDate : 7;
                    end = new Date(this.currentDate.toDate);
                    start = new Date(end);
                    start.setHours(0, 0, 0, 0);
                    end.setDate(start.getDate() + deltaDate);
                    const today = new Date()
                    if (end.getTime() > today.getTime()) {
                        end = new Date(today.getTime())
                    }
                    end.setHours(0, 0, 0, 0);
                }

                this.currentDate = {fromDate: start, toDate: end}
            } else {
                date = {fromDate: new Date(), toDate: new Date(this.currentDate.toDate.getTime())}
                date.toDate.setDate(date.toDate.getDate() + this.deltaDate as number);
                this.rangeForm.get('end')?.setValue(date.toDate, {emitEvent: true, onlySelf: true});
            }
        } else if (this.deltaMonth != undefined) {
            date = this.hunaDateService.getDeltaMonth(this.currentDate.toDate, +this.deltaMonth as number);
            this.currentDate = date;
        } else if (this.deltaYear != undefined) {
            date = this.hunaDateService.getDeltaYear(this.currentDate.toDate, +this.deltaYear as number);
            this.currentDate = date;
        }
    }

    get disableNextWeek() {
        const today = new Date();
        today.setHours(0, 0, 0, 0)
        const toDate = new Date(this.currentDate?.toDate);
        toDate.setHours(0, 0, 0, 0)
        return (toDate.getTime()! >= today.getTime())
    }

    openPicker(picker: any) {
        if (!this.disabled) {
            switch (this.typeDate) {
                case "deltaYear":
                    break
                case "deltaMonth":
                    const years: TypeSelectChipsDialog[] = [];
                    const today = new Date()
                    for (let year = 2019; year <= today.getFullYear(); year++) {
                        years.push({
                            type: 'number',
                            traductionKey: year.toString(),
                            id: year.toString()
                        })
                    }
                    const months: TypeSelectChipsDialog[] = [
                        {type: 'date', traductionKey: 'months.reduced.0', id: '0'},
                        {type: 'date', traductionKey: 'months.reduced.1', id: '1'},
                        {type: 'date', traductionKey: 'months.reduced.2', id: '2'},
                        {type: 'date', traductionKey: 'months.reduced.3', id: '3'},
                        {type: 'date', traductionKey: 'months.reduced.4', id: '4'},
                        {type: 'date', traductionKey: 'months.reduced.5', id: '5'},
                        {type: 'date', traductionKey: 'months.reduced.6', id: '6'},
                        {type: 'date', traductionKey: 'months.reduced.7', id: '7'},
                        {type: 'date', traductionKey: 'months.reduced.8', id: '8'},
                        {type: 'date', traductionKey: 'months.reduced.9', id: '9'},
                        {type: 'date', traductionKey: 'months.reduced.10', id: '10'},
                        {type: 'date', traductionKey: 'months.reduced.11', id: '11'},
                    ];


                    const getChipsDisabled: (chip: TypeSelectChipsDialog, slidesValue: TypeSelectChipsDialog) => boolean = (chip, slidesValue) => {
                        if (isNotNullOrUndefined(slidesValue)) {
                            const today = new Date();
                            const year = parseInt(slidesValue.id);
                            const month = parseInt(chip.id);
                            return year == today.getFullYear() && month > today.getMonth();
                        } else {
                            return false
                        }
                    }
                    this.openDialogService.openDialogSelectChips(years, months, false, getChipsDisabled).subscribe(response => {
                        if (isNotNullOrUndefined(response)) {
                            const month = parseInt(response.selectedChips[0].id);
                            const year = parseInt(response.slidesValue.id);
                            if (!isNaN(month) && !isNaN(year)) {
                                const fromDate = new Date();
                                fromDate.setFullYear(year);
                                fromDate.setMonth(month)
                                fromDate.setDate(1)
                                fromDate.setHours(0, 0, 0, 0)
                                const toDate = new Date(fromDate.getTime())
                                toDate.setMonth(fromDate.getMonth() + 1)
                                toDate.setDate(1)
                                toDate.setHours(0, 0, 0, 0)
                                this.currentDate = {fromDate, toDate}
                            }
                        }
                    })
                    break
                default:
                    picker.open();
                    break
            }

        }
    }

    closePicker() {

    }
}
